module.exports = __webpack_public_path__ + "static/media/2 4 tattoo arm pirate mermaid treasure skull nautical.1280x1707.1485e0e9.webp";